import { CSSProperties } from 'aphrodite/no-important';
import { style } from './typography.style';
import { Reporter } from '../base/errorHandling/ErrorReporting';

type Context<T> = { [key: string]: T };
export type ThemeData = CSSProperties | { [key: string]: (string | object) };

export const themeKeys = ['h1', 'h2', 'h3', 'h4', 'p', 'span', 'ul'];

type GlobalStyles = {
  h3: ThemeData,
  h4: ThemeData,
  p: ThemeData,
};
let globalStyles: GlobalStyles = { h4: {}, h3: {}, p: {} };

const removeUndefinedStyles = (reporter: Reporter, styleObject: ThemeData): ThemeData => {
  return Object.keys(styleObject).reduce((prevValue: ThemeData, key: string) => {
    if (typeof styleObject[key] !== 'undefined') {
      return {
        ...prevValue,
        [key]: styleObject[key],
      };
    }
    reporter.reportWarning(`Style objects in Theme should not contain undefined properties: key:${key} has undefined value`);
    return prevValue;
  }, {});
};

const constructTagStyle = (reporter: Reporter, tagStyle: CSSProperties) => {
  return {
    ...removeUndefinedStyles(reporter, tagStyle),
    ...style,
  };
};

export const getGeneratedGlobalStyles = () => {
  return {
    h3: () => ({ style: globalStyles.h3 }),
    h4: () => ({ style: globalStyles.h4 }),
    p: () => ({ style: globalStyles.p }),
  };
};

export const generateGlobalStyles = (reporter: Reporter, configuration: Context<any>) => {
  const styles = Object.keys(configuration).reduce((prevValue, tag) => {
    if (themeKeys.includes(tag)) {
      const { tagStyle } = configuration[tag];
      if (typeof tagStyle !== 'undefined') {
        return {
          ...prevValue,
          [tag]: constructTagStyle(reporter, tagStyle),
        };
      }
    }
    return prevValue;
  }, {});

  globalStyles = styles as GlobalStyles;

  return styles;
};
